import { FAQS } from "@/lib/data";
import { Reveal, Label } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  return (
    <section
      id="faq"
      data-testid="faq"
      className="relative py-24 md:py-32 bg-[#111827] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Reveal>
            <Label>08 — FAQ</Label>
            <h2 className="font-display font-bold text-3xl sm:text-4xl mt-5 tracking-tight leading-tight">
              Domande frequenti.
            </h2>
            <p className="mt-4 text-slate-400 leading-relaxed">
              Hai un dubbio non elencato? Scrivimi: rispondo in modo chiaro, senza gergo tecnico
              inutile.
            </p>
          </Reveal>
        </div>

        <div className="md:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-white/10"
                >
                  <AccordionTrigger className="font-display text-lg md:text-xl font-bold tracking-tight text-left hover:text-[#00C8D7] hover:no-underline py-6">
                    <span className="flex items-center gap-4">
                      <span className="font-mono-tech text-sm text-[#00C8D7]">0{i + 1}</span>
                      {f.q}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6 pl-10">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
